module.exports = __webpack_public_path__ + "static/Apercu-Light-1295110faadcf5673c13c8a3f5203246.ttf";